var exports = {
  "x6": "AddGuildButton.module__button___dUxSaH",
  "td": "AddGuildButton.module__iconText___dUxSaH",
  "ro": "AddGuildButton.module__menuIcon___dUxSaH",
};

module.exports = exports;
